<template>
  <div class="pop">
    <div class="bg-in" v-if="this.internation == 'IN'">
      <img
        src="https://s3.ap-southeast-1.amazonaws.com/media.app.betajay.com/front/jili2_popw_in.png"
        style="max-width: 90vw; height: auto; border-radius: 10px"
        @click="goToPromotion"
      >
      <div class="cancel-btn" v-show="delayedAWhile" @click="close">
        <img :src="cancelWhite" alt="cancel">
      </div>
    </div>
    <div class="bg-in" v-else>
      <img
        src="https://s3.ap-southeast-1.amazonaws.com/media.app.betajay.com/front/jili2_popw_en.png"
        style="max-width: 90vw; height: auto; border-radius: 10px"
        @click="goToPromotion"
      >
      <div class="cancel-btn" v-show="delayedAWhile" @click="close">
        <img :src="cancelWhite" alt="cancel">
      </div>
    </div>
    <IFrame3Part
      :iFrameSrc="iFrameSrc"
      :handelClose="() => handleCloseIFrame3Part()"
      v-if="showPromotion"
    >
    </IFrame3Part>
  </div>
</template>

<script>
import cancelWhite from '@/assets/images/common/cancelWhite.svg'
import IFrame3Part from '@/components/IFrame3Part/index'

export default {
  name: 'JiliActivity2Pop',
  props: ['handleClose'],
  data () {
    return {
      cancelWhite,
      iFrameSrc: '',
      showPromotion: false,
      internation: '',
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      delayedAWhile: false
    }
  },
  watch: {
    '$store.state.locale': function () {
      this.onInit()
    }
  },
  components: {
    IFrame3Part
  },
  mounted () {
    if (localStorage.getItem('locale') === 'IN') {
      this.internation = 'IN'
      this.iFrameSrc = 'https://history.jlfafafa3.com/hi-IN/action/20230816U/slot'
    } else {
      this.internation = 'INT'
      this.iFrameSrc = 'https://history.jlfafafa3.com/en-US/action/20230816U/slot'
    }
    this.onInit()
  },
  methods: {
    onInit: function () {
      let that = this
      setTimeout(() => {
        that.delayedAWhile = true
        return null
      }, 3000)
    },
    close () {
      this.handleClose()
    },
    goToPromotion () {
      if (this.userInfo) {
        this.showPromotion = true
      }
    },
    handleCloseIFrame3Part () {
      this.showPromotion = false
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped>
  .pop {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,.6);
    z-index: 9;
    padding: 40px 20px;
    box-sizing: border-box;
    overflow: auto;

    .bg-in {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 50.05%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 96vw;

      .cancel-btn {
        width: 28px;
        height: 28px;
        margin-top: 14px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/JiliActivity2Pop/index.vue